const $urlFormat = function (text = '') {
    var urlRegex = /(https?:\/\/[^\s]+)/g
    return text.replace(urlRegex, function(url) {
      return  ` <a href="${url}" target="_blank"  >${url}</a>`
    })
}
let urlFormat = {
  install: (app) => {
    app.config.globalProperties.$urlFormat = $urlFormat
    app.provide('urlFormat', $urlFormat)
  }
}

export default urlFormat